import { IconFilter } from '@tabler/icons-react';

import type { TransformDatasetInput } from './schema.ts';
import type { TransformDatasetOutput } from './types.ts';
import { ToolCompleteBadges } from '#plugin-chat/components/tool-display/ToolCompleteBadges.tsx';
import { ToolDisplay } from '#plugin-chat/components/tool-display/ToolDisplay.tsx';
import { useToolPart } from '#plugin-chat/hooks/useToolPart.ts';
import type { ToolProgressComponent } from '#plugin-chat/lib/tool/progress-registry.ts';

/**
 * UI component for TransformDatasetTool.
 */
export function RenderTransformDatasetTool() {
  const toolPart = useToolPart<TransformDatasetInput, TransformDatasetOutput>();

  return (
    <ToolDisplay>
      <ToolDisplay.Running>Processing data...</ToolDisplay.Running>
      <ToolDisplay.Complete color="var(--mantine-color-blue-4)" icon={IconFilter}>
        <span>Data processed</span>
        <ToolCompleteBadges
          inputDataset={toolPart.args?.inputDataset}
          outputDataset={toolPart.args?.outputDataset}
          rowCount={undefined}
        />
      </ToolDisplay.Complete>
      <ToolDisplay.Error>Failed to process data</ToolDisplay.Error>
    </ToolDisplay>
  );
}
/**
 * Progress component for TransformDatasetTool.
 *
 * Rendered inside the "AiPSO Agent is ..." progress bubble while the tool is running.
 */
export const ProgressTransformDatasetTool: ToolProgressComponent<
  TransformDatasetInput,
  TransformDatasetOutput
> = () => <>processing data...</>;
